import i18n from "../../../../i18n";
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: "name",
      label: i18n.t('common_words.names'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: "document_id",
      label: i18n.t('common_words.document_number'),
      minWidth: 145,
    },
    {
      prop: "username",
      label: i18n.t('common_words.user'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: "email",
      label: i18n.t('common_words.email'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: "nfc_id",
      label: i18n.t('common_words.nfc'),
      minWidth: 120,
    },
    {
      prop: "role_name",
      label: i18n.t('common_words.profile'),
      minWidth: 150,
      sortable: true,
    }

  ];
  const Search = { ...Tables.Search };
  return { Table, Search };

};
export default configTable;

